var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('div',[(_vm.xs)?_c('div',{staticClass:"page-home-featured-mobile"},[_c('carousel',{ref:"carousel",attrs:{"perPage":1,"autoplay":"","autoplayHoverPause":"","autoplayTimeout":_vm.carouselTimeout,"loop":""}},_vm._l((_vm.slicedItems),function(ref,i){
var id = ref.id;
var title = ref.title;
var img = ref.img;
var category = ref.category;
var date = ref.date;
return _c('slide',{key:i},[_c('ArticleCard',{attrs:{"id":id,"title":title,"img":img,"date":date,"category-title":category.title,"category-color":category.color,"type":"featured"}})],1)}),1)],1):_c('div',{staticClass:"page-home-featured-desktop grey lighten-4"},_vm._l((_vm.slicedItems),function(ref,i){
var id = ref.id;
var title = ref.title;
var img = ref.img;
var category = ref.category;
var date = ref.date;
return _c('ArticleCard',{key:i,attrs:{"id":id,"title":title,"img":img,"date":date,"category-title":category.title,"category-color":category.color,"type":"featured"}})}),1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }